/**
 * Gets the number of user recipes from the global Zustand store.
 * @return {number} The number of user recipes.
 */
export function getUserRecipeAmount(): number {
	const lists = window.valioApp.store.data.lists;
	let count = 0;

	if (!lists) {
		return 0;
	}

	for (const list of Object.values(lists)) {
		if (list.items.length === 0) {
			continue;
		}

		count += list.items.length;
	}

	return count;
}
